import { z } from "zod";
import { positiveNumber, nonNegativeInteger, postiveNumberZeroToOneHundred } from "@/utils/form";
import { SiteVisitTypeEnum } from "@/graphql/__generated__/graphql";
import { t } from "i18next";

export const SiteVisitSchema = z.object({
  duration: positiveNumber(t("addsitevisit.duration")),
  margin: postiveNumberZeroToOneHundred(t("addsitevisit.margin")),
  type: z.enum([SiteVisitTypeEnum.Closing, SiteVisitTypeEnum.Control, SiteVisitTypeEnum.Opening], {
    message: t("schemas:sitevisit.typerequired"),
  }),
  mondayDay: nonNegativeInteger("Monday Day"),
  mondayNight: nonNegativeInteger("Monday Night"),
  tuesdayDay: nonNegativeInteger("Tuesday Day"),
  tuesdayNight: nonNegativeInteger("Tuesday Night"),
  wednesdayDay: nonNegativeInteger("Wednesday Day"),
  wednesdayNight: nonNegativeInteger("Wednesday Night"),
  thursdayDay: nonNegativeInteger("Thursday Day"),
  thursdayNight: nonNegativeInteger("Thursday Night"),
  fridayDay: nonNegativeInteger("Friday Day"),
  fridayNight: nonNegativeInteger("Friday Night"),
  saturdayDay: nonNegativeInteger("Saturday Day"),
  saturdayNight: nonNegativeInteger("Saturday Night"),
  sundayDay: nonNegativeInteger("Sunday Day"),
  sundayNight: nonNegativeInteger("Sunday Night"),
  holidayDay: nonNegativeInteger("Holiday Day"),
  holidayNight: nonNegativeInteger("Holiday Night"),
  startDate: z.date().optional(),
  endDate: z.date().optional(),
}).refine(data => {
  return (
    data.mondayDay > 0 ||
    data.mondayNight > 0 ||
    data.tuesdayDay > 0 ||
    data.tuesdayNight > 0 ||
    data.wednesdayDay > 0 ||
    data.wednesdayNight > 0 ||
    data.thursdayDay > 0 ||
    data.thursdayNight > 0 ||
    data.fridayDay > 0 ||
    data.fridayNight > 0 ||
    data.saturdayDay > 0 ||
    data.saturdayNight > 0 ||
    data.sundayDay > 0 ||
    data.sundayNight > 0 ||
    data.holidayDay > 0 ||
    data.holidayNight > 0
  );
}, {
  message: "At least one of the week days or nights must be at least 1.",
  path: ["mondayDay"],
}).check((ctx) => {
  const { startDate, endDate } = ctx.value;

  // Check if end date is after start date
  if (startDate && endDate && endDate.getTime() < startDate.getTime()) {
    ctx.issues.push({
      code: "custom",
      path: ["endDate"],
      message: t("schemas:createtender.contract.enddateafterstartdate"),
      input: ctx.value.endDate,
    });
  }
});

export const SiteVisitDefaultValues = {
  duration: 0,
  margin: 0,
  type: "" as SiteVisitTypeEnum,
  mondayDay: 0,
  mondayNight: 0,
  tuesdayDay: 0,
  tuesdayNight: 0,
  wednesdayDay: 0,
  wednesdayNight: 0,
  thursdayDay: 0,
  thursdayNight: 0,
  fridayDay: 0,
  fridayNight: 0,
  saturdayDay: 0,
  saturdayNight: 0,
  sundayDay: 0,
  sundayNight: 0,
  holidayDay: 0,
  holidayNight: 0,
  startDate: undefined,
  endDate: undefined,
};

export type TSiteVisitSchema = z.infer<typeof SiteVisitSchema>;
